<template>
  <div id="rastrearpedido" class="container br-2-blue bg-white">
    <div class="panel panel-default">
      <div class="panel-heading font-bold">
        <h2 class="text-center">Rastrea tu pedido</h2>
      </div>

      <form class="form-horizontal" @submit.prevent="consultarEstado">
        <div class="panel-body separador">

          <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
              <span class="text-xs text-danger help-block m-b-none">
                * Campos requeridos.
              </span>
            </div>
          </div>
        
          <div class="form-group">
            <label class="col-sm-12">
              Buscar envíos por: Número de guía / Número de tracking *
            </label>

            <div class="col-sm-12">
              <input
                class="form-control text-uppercase"
                type="text"
                v-model="referencia"
                required
              />
            </div>

            <!-- Errores -->
            <div v-if="errors.length" class="col-sm-12">
              <ul class="text-danger">
                <li v-for="error in errors" :key="error">
                  {{ error }}
                </li>
              </ul>
            </div>

          </div>
        </div>

        <div class="form-group m-b-xs m-t-xs">
          <div class="col-sm-12 text-right">
            <button type="submit" class="btn btn-blue btn-addon">
              Consultar
            </button>
          </div>
        </div>
      </form>

      <!-- TABLA -->
      <div v-if="mostrarTabla" id="tabla" class="separador">
        <div class="table-responsive app-table">

          <!-- Resumen -->
          <table class="table table-striped b-t table-color">
            <thead>
              <tr>
                <th>Sello</th>
                <th>Referencia</th>
                <th>Fecha / Hora</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ sello }}</td>
                <td>{{ referencia2 }}</td>
                <td v-if="seguimiento.length">
                  {{ seguimiento[0].fecha }}
                </td>
                <td v-else></td>
                <td>{{ estadoEnvio }}</td>
              </tr>
            </tbody>
          </table>

          <br>

          <!-- Detalle -->
          <table class="table table-striped b-t table-color">
            <tbody>
              <tr><th>No de Sello</th><td>{{ sello }}</td></tr>
              <tr><th>Guía transportadora</th><td>{{ guiaServientrega }}</td></tr>
              <tr><th>Estado</th><td>{{ estadoEnvio }}</td></tr>
              <tr><th>Destino final</th><td>{{ destino }}</td></tr>
              <tr><th>Peso + Peso volumen</th><td>{{ peso }} + {{ peso_volumen }}</td></tr>
              <tr><th>Novedad</th><td>{{ novedad }}</td></tr>
            </tbody>
          </table>

          <br>

          <!-- Seguimiento -->
          <table class="table table-striped b-t table-color">
            <thead>
              <tr>
                <th>Fecha / Hora</th>
                <th>Seguimiento</th>
                <th>Observación</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="seg in seguimiento" :key="seg.id">
                <td>{{ seg.fecha }}</td>
                <td>{{ seg.estadoAlt }}</td>
                <td>{{ seg.observacion }}</td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getSelectedEnvironment, api } from "../plugins/api_conect";

export default {
  data() {
    return {
      errors: [],
      referencia: "",
      destino: null,
      estadoEnvio: null,
      fecha_Entrega: null,
      guiaServientrega: null,
      novedad: null,
      peso: null,
      peso_volumen: null,
      referencia2: null,
      seguimiento: [],
      sello: null,
      descripcion_transportadora: null,
      url_transportadora: null,
      mostrarTabla: false
    };
  },

  methods: {
    consultarEstado() {
      this.errors = [];
      this.mostrarTabla = false;

      // Limpiar espacios en blanco
      this.referencia = this.referencia.trim();

      if (!this.referencia) {
        this.errors.push("Este campo es requerido.");
        return;
      }

      const currentEnvironment = getSelectedEnvironment();

      api()
        .get(`/api/consulta-estado/${this.referencia}/${currentEnvironment.app_id}`)
        .then((response) => {
          const { data } = response;

          this.destino = data.datos?.Destino ?? null;
          this.estadoEnvio = data.datos?.Estado_Envio ?? null;
          this.fecha_Entrega = data.datos?.Fecha_Entrega ?? null;
          this.guiaServientrega = data.datos?.Guia_Servientrega ?? null;
          this.novedad = data.datos?.Novedad ?? null;
          this.peso = data.datos?.Peso ?? null;
          this.peso_volumen = data.datos?.Peso_volumen ?? null;
          this.referencia2 = data.datos?.Referencia ?? null;
          this.seguimiento = data.datos?.Seguimiento ?? [];
          this.sello = data.datos?.Sello ?? null;
          this.descripcion_transportadora = data.datos?.Descripcion_transportadora ?? null;
          this.url_transportadora = data.datos?.url_transportadora ?? null;

          this.mostrarTabla = true;
        })
        .catch((error) => {
          const status = error.response?.status;

          if (status === 404) {
            this.$swal("Error", error.response.data.msg, "error");
          } else if (status === 422) {
            this.errors = error.response.data.errors || ["Datos inválidos"];
          } else {
            this.$swal("Error", "Error inesperado", "error");
          }
        });
    }
  }
};
</script>

<style scoped>
#rastrearpedido {
  margin-top: 25px;
  margin-bottom: 25px;
  padding: 10px;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.table-color {
  color: black !important;
  background: aliceblue !important;
}
</style>